export default __webpack_public_path__ + "assets/models/0cad20e4df2867e7523e508a54aaede1.glb";